/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from document (page cart; side cart removed 2026-08-01).
 * - openCart: always navigate to full /cart page (never open a drawer).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document,
  });

  actions.openCart.configure({
    async handler() {
      window.location.href = Theme.routes.cart_url || '/cart';
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
